import makeStyles from '@mui/styles/makeStyles'

export const useStyles = makeStyles(({ spacing, breakpoints }) => ({
  modal: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    [breakpoints.down('md')]: {
      width: '90%',
      padding: '30px'
    },
    [breakpoints.up('md')]: {
      width: 625,
      padding: '48px'
    },
    borderRadius: '4px',
    boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
    backgroundColor: '#fff'
  },
  title: {
    fontSize: '20px',
    fontWeight: 700,
    lineHeight: '24px',
    textAlign: 'center',
    marginBottom: spacing(2)
  },
  successIcon: {
    marginBottom: '10px',
    fontSize: 64,
    color: 'rgba(47, 168, 62, 1)'
  },
  description: {
    fontSize: '18px',
    textAlign: 'center',
    marginBottom: spacing(2)
  },
  closeBtn: {
    margin: '20px 0px 8px 0px',
    display: 'flex',
    padding: '10px 18px',
    justifyContent: 'center',
    borderRadius: '4px'
  }
}))
